import { type TJsonQuery, getOfferTypeFromJsonQuery, getTermsValue, isResidential } from '@/packages/JsonQuery';

import { getCommercialLink } from './getCommercialLink';
import { getResidentialLink } from './getResidentialLink';

export function getLink(jsonQuery: TJsonQuery): string {
  const offerType = getOfferTypeFromJsonQuery(jsonQuery);
  const regionIds = getTermsValue('region')(jsonQuery);
  const regionId = regionIds ? regionIds[0] : undefined;

  if (isResidential(offerType)) {
    return getCommercialLink(regionId);
  } else {
    return getResidentialLink(regionId);
  }
}
